export default "__VITE_ASSET__DxAbn2dY__"